const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Tehke oma valik siin.",
  seeAll: "Vaata kõiki",
  clear: "Puhasta",
  back: "Tagasi",
  save: "Salvesta",
  close: "Sulge",
  of: "Kuni",
  to: "jaoks",
  copyrights: "© {date} Bridgestone Solutions. Kõik õigused kaitstud.",
  pageNotFound: "Lehte ei leitud",
  accessDenied: "Juurdepääs keelatud",
  search: "Otsi",
  year: "Aasta",
  buttons: {
    loading: "Laadimine...",
    export: "Ekspordi",
    delete: "Kustuta",
    save: "Salvesta",
    cancel: "Tühista",
    next: "Järgmine",
    back: "Tagasi",
    skip: "Jäta vahele",
    send: "Saada",
    readNow: "Lugege kohe",
    pointsList: "Punktide loend",
    clear: "Puhasta",
    more: "Rohkem",
    close: "Sulge",
    reportError: "Teata veast",
    accept: "Nõustu",
    download: "Laadi alla",
    downloadAll: "Laadi kõik alla",
    selectAll: "Vali kõik",
    deselectAll: "Tühista valik",
    downloadSelection: "Laadi valik alla",
    dealerInfoDownload: "Laadi alla",
    toTheBasket: "Korvi",
    toOrderDelivery: "Jätka tarneaadressile",
    discover: "Avasta",
    newAddress: "Loo uus tarneaadress",
    selectAddressBtn: "Vali tarneaadress",
    toOrderSummary: "Tellimuse ülevaatesse",
    placeOrder: "Siduv tellimus",
    toDashboard: "Avalehele",
    newOrder: "Uus tellimus",
    userOrders: "Sinu tellimusteni",
    toSearch: "Otsi",
    select: "Vali",
    moreCustomerNumbers: "+ LISA ROHKEM KLIENDINUMBREID",
    loadMore: "Laadi rohkem",
    toStaffDashboard: "Töölauale",
    toQuiz: "Viktoriinile",
    vouchers: "Vautšerid",
    exchangeVoucher: "Lunasta vautšerikood",
    confirm: "Kinnita",
    sharePoints: "Jaga punkte",
    create: "Loo",
    update: "Uuenda",
    toBDrive: "B-Drive'i",
    preview: "Eelvaade",
    clickHere: "Vaata üksikasju",
    setFilters: "Palun määrake <b>iga veeru kohta maksimaalselt üks filter</b>",
    all: "Kõik",
  },
  tooltips: {
    info: "Kas vajate abi? +371 29 16 22 12",
  },
  confirmation: {
    header: "Kinnitus vajalik",
    message: "Kas soovite selle kirje kustutada?",
  },
  nav: {
    consents: "Nõusolekud",
    dashboard: "Avaleht",
    accountDashboard: "Töölaud",
    account: "Minu Profiil",
    mailbox: "Postkast",
    singleMailbox: "Sõnumid",
    stammdaten: "Põhiandmed",
    news_feeds: "Uudised",
    pointsOverview: "Punktide ülevaade",
    rewardsOverview: "Punktide ülevaade",
    about: "BS Plusi kohta",
    service_number: "Võta ühendust teenindusega",
    shop: "Preemiapood",
    salesPromotions: "Müügikampaaniad",
    promotions: "Minu konto",
    shopCategory: "Preemiapood",
    productDetails: "Toote üksikasjad",
    userOrders: "Kasutaja tellimused",
    shoppingCart: "Ostukorv",
    orderDelivery: "Tarneaadress",
    orderSummary: "Tellimuse ülevaade",
    orderComplete: "Tellimus lõpetatud",
    text_page: "Staatiline leht",
    staff: "Teeninduse töölaud",
    onlineTrainings: "Veebikoolitused",
    trainings: "Koolitused",
    training: "Koolitus",
    trainingForm: "Koolitusvorm",
    staffVouchers: "Vautšerid",
    wholesalerVouchers: "Vautšerid",
    brochure_prices: "Hinnakirjad ja brošüürid",
    investment: "Investeeringutoetus",
    media: "Meedia",
    medias: "Meedia",
    contact_service: "Kontakt ja teenindus",
    productInfo: "TOOTEINFO",
    bDrive: "Toodete pildid",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Osalemistingimused",
    first_stop: "Bridgestone rehvigarantii",
    payouts: "Payouts",
},
  breadcrumbs: {
    dashboard: "Avaleht",
    accountDashboard: "Töölaud",
    account: "Minu Profiil",
    mailbox: "Postkast",
    singleMailbox: "Sõnumid",
    stammdaten: "Põhiandmed",
    news_feeds: "Uudised",
    pointsOverview: "Punktide ülevaade",
    rewardsOverview: "Punktide ülevaade",
    about: "BS Plusi kohta",
    service_number: "Võta ühendust teenindusega",
    shop: "Preemiapood",
    salesPromotions: "Müügikampaaniad",
    promotions: "Minu konto",
    shopCategory: "Preemiapood",
    productDetails: "Toote üksikasjad",
    userOrders: "Kasutaja tellimused",
    shoppingCart: "Ostukorv",
    orderDelivery: "Tarneaadress",
    orderSummary: "Tellimuse ülevaade",
    orderComplete: "Tellimus lõpetatud",
    staff: "Teeninduse töölaud",
    onlineTrainings: "Veebikoolitused",
    trainings: "Koolitused",
    training: "Koolitus",
    trainingForm: "Koolitusvorm",
    staffVouchers: "Vautšerid",
    wholesalerVouchers: "Vautšerid",
    brochure_prices: "Hinnakirjad ja brošüürid",
    investment: "Investeeringutoetus",
    media: "Meedia",
    medias: "Meedia",
    contact_service: "Kontakt ja teenindus",
    productInfo: "TOOTEINFO",
    bDrive: "Toodete pildid",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Osalemistingimused",
    first_stop: "Bridgestone rehvigarantii",
    payouts: "Payouts",
},
  menu: {
    account: "Minu Profiil",
    plus: 'Bridgestone <span class="text-danger">Plus</span> kohta',
    salesSupport: "Müügitoetus",
    mailbox: "Postkast",
    about: "BS Plusi kohta",
    trainingAndCourses: "Koolitused ja kursused",
    externalTraining: "Väline koolitus",
    productInfo: "Tooteinfo",
    productBrochures: "Tootebrošüürid",
    priceLists: "Hinnakirjad",
    price: "Hind",
    complaintForm: "Kaebuse vorm",
    sales_support: "Müügitoetus",
    contact_service: "Kontakt ja teenindus",
    logOut: "Logi välja",
    news: "Uudised",
    news_feeds: "Uudised",
    service_number: "Võta ühendust teenindusega",
    salesPromotions: "Müügikampaaniad",
    shop: "Pood",
    onlineTrainings: "Veebikoolitused",
    trainings: "Koolitused",
    brochure_prices: "Hinnakirjad ja brošüürid",
    media: "Meedia",
    medias: "Meedia",
    stammdaten: "Põhiandmed",
    preislisten: "Hinnakirjad",
  },
  validation: {
    requiredField: "Kohustuslik väli",
  },
  sortBy: {
    default: "Sordi järgi",
    desc: "Sordi järgi: Uusimad",
    asc: "Sordi järgi: Vanimad",
    name: "Nimi",
    date: "Kuupäev",
    choiceBy: "Sorteeri",
  },
  month: {
    1: "jaanuar",
    2: "veebruar",
    3: "märts",
    4: "aprill",
    5: "mai",
    6: "juuni",
    7: "juuli",
    8: "august",
    9: "september",
    10: "oktoober",
    11: "november",
    12: "detsember"
  },
};


export default {
  messages,
};
